import { Download } from "@mui/icons-material";
import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  getNoAuthCallParams,
  makeCall,
} from "../../../../utils/service";

export async function getAllUsers(userId: string) {
  try {
    const callParams = await getCallParams("GET");
    console.log(callParams, "callParams");
    const response = await makeCall(
      urls.LEADDATA + `?id=${userId}&start_date=&end_date=`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllBulkUploade(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    console.log(callParams, "callParams");
    const response = await makeCall(
      urls.UPLOADLEAD + `?id=${payload.userId}&start_date=&end_date=&page=${payload.pageNo}&limit=${payload.pageSize}&search=${payload.search || ""}&formId=${payload.formId || ""}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDateWiseLead(
  userId: string,
  from: string,
  to: string
) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.LEADDATA + `?id=${userId}&start_date=${from}&end_date=${to}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllForms() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLLEADS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTeamData(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETTEAMDROP}/${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTeamMembersData(payload: any) {
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(`${urls.GETMEMBERSDROP}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function downloadCsv(path: any) {
  try {
    // const filePath = path.replace(/^https:\/\//, "");
    const callParams = await getCallParams("GET", path);
    const response = await makeCall(`${path}`, callParams);
    return Download(response);
  } catch (error) {
    throw error;
  }
}
export async function getAllTeam() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETTEAMDROP}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllStage() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLSTAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllSource() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLSOURSE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getReminder(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETREMINDER}${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function postOfficeDetails() {
  try {
    const callParams = await getCallParams("POST");
    const response = await makeCall(urls.ADDUSEROFFICE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}

export async function changeStatusApi(status: any, userId: any) {
  const payload = {
    id: userId,
    status: status == 0 ? 1 : 0,
  };
  try {
    const callParams = await getCallParams("PUT", payload);
    const response = await makeCall(urls.USERUPDATE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function changeStage(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATESTAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function changeAt(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEAI, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function saveReminder(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.UPDATEREMINDER, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function assignToMembers(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.ASSIGNTOMEMBERS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllReminder(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.UPDATEREMINDER + `/${id?.id}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
